import axios from 'axios';
import { supabase } from '../lib/supabase';

// Get the API URL from environment variables or use a relative URL if deployed with the backend
const apiUrl = process.env.REACT_APP_API_URL || '';

// IMPORTANT: URL Convention
// This application follows a consistent pattern of NOT using trailing slashes in API routes.
// All API endpoints should be called without trailing slashes (e.g., "/api/resource" not "/api/resource/").
// This matches the backend FastAPI implementation which also does not use trailing slashes.

console.log('API service initializing with base URL:', apiUrl);

// Create axios instance with base URL
const api = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to add auth token to requests
api.interceptors.request.use(async (config) => {
  console.log(`API Request: ${config.method.toUpperCase()} ${config.url}`);
  
  try {
    const { data: { session } } = await supabase.auth.getSession();
    
    if (session) {
      console.log('Auth session found, adding token to request');
      config.headers.Authorization = `Bearer ${session.access_token}`;
    } else {
      console.warn('No auth session found for API request');
    }
  } catch (error) {
    console.error('Error getting auth session:', error);
  }
  
  return config;
}, (error) => {
  console.error('API request interceptor error:', error);
  return Promise.reject(error);
});

// Add response interceptor to log errors
api.interceptors.response.use(
  (response) => {
    console.log(`API Response: ${response.status} for ${response.config.url}`);
    return response;
  },
  (error) => {
    console.error('API Error Response:', error?.response?.status, error?.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default api; 